import { Tooltip } from "antd";
import { ReactNode } from "react";
import ActionTextIcon from "../../icons/ActionTextIcon";
import { AntIconType } from "../../icons/AntIcon";

interface Props {
  label: ReactNode;
  actionText: string;
  icon: AntIconType;
  path: string;
  disabled?: boolean;
}

export const LabelWithAction = ({ label, actionText, icon, path, disabled }: Props) => (
  <span>
    {/* The non-breaking space keeps the icon on the line of the label's last word */}
    {label}&nbsp;
    <Tooltip title={actionText}>
      <span>
        <ActionTextIcon path={path} icon={icon} color="blue" disabled={disabled} />
      </span>
    </Tooltip>
  </span>
);
